export default "__VITE_ASSET__BoJfrQ5z__"